import { render, staticRenderFns } from "./DealOrder.vue?vue&type=template&id=5a25b672&scoped=true&"
import script from "./DealOrder.vue?vue&type=script&lang=ts&"
export * from "./DealOrder.vue?vue&type=script&lang=ts&"
import style0 from "./DealOrder.vue?vue&type=style&index=0&id=5a25b672&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a25b672",
  null
  
)

export default component.exports